<app-container class="auth-container" [noPadding]="handsetService.isXs" fxLayoutAlign="center" maxWidth="516px"
               ngClass.xs="xs">

  <mat-card class="card" fxLayout="column" ngClass.xs="xs">
    <mat-card-header class="header-with-big-space" fxLayout="column" fxLayoutAlign="center center">
      <a class="logo" href="https://payka.pl/">
        <img src="/assets/images/logo-payka/logo_payka.svg" alt="payka-logo" />
      </a>
      <h1>
        {{ headerText }}
      </h1>
      <p>
        <ng-container *ngIf="activeStep=== 2 || activeStep === 4; else smallTitle">
          <ng-container *ngIf="activeStep=== 2; else phoneTitle">
            {{ smallHeaderText }} <b>{{ emailText }}</b>
          </ng-container>
          <ng-template #phoneTitle>
            {{ smallHeaderText }} <b>{{ phoneText }}</b>
          </ng-template>
        </ng-container>
        <ng-template #smallTitle>
          {{ smallHeaderText }}
        </ng-template>
      </p>
    </mat-card-header>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <mat-card-content>


        <div fxLayout="column" fxLayoutAlign="start stretch" class="form-container">
          <app-step-email *ngIf="activeStep === 1"
                          formGroupName="addEmail" [statemates]="regulations"></app-step-email>

          <app-step-email-verification *ngIf="activeStep === 2"></app-step-email-verification>

          <app-step-phone *ngIf="activeStep === 3"
                          formGroupName="addPhone"></app-step-phone>

          <app-step-phone-verification *ngIf="activeStep === 4"
                                       formGroupName="verifyPhone"></app-step-phone-verification>

          <app-step-password *ngIf="activeStep === 5"
                             formGroupName="setPassword"></app-step-password>


          <div *ngIf="!referralCodeInputVisible && appConfig.config.codeRedemptionActive"
               class="referral"
               id="referral-code-visibility-toggle">
            <app-icon name="redeem" class="mr-10"></app-icon>
            <a (click)="referralCodeInputVisible = true"> Posiadasz kod polecający? </a>
          </div>
        </div>

        <mat-form-field *ngIf="referralCodeInputVisible" [hideRequiredMarker]="true" appearance="outline">
          <mat-label>Kod polecający (opcjonalne)</mat-label>
          <input
            [dropSpecialCharacters]="false"
            [formControl]="form.referralCode"
            [specialCharacters]="['-']"
            mask="AAAA-AAAA"
            matInput
            oninput="value = value.toUpperCase()"
            placeholder="XXXX-XXXX"
            tabindex="0"
            type="text"
            appGtmFormEvent
            [eventField]="'referralCode'"
            [eventForm]="formName" />
          <mat-error
            *ngIf="form.referralCode.invalid && (form.referralCode.dirty || !form.referralCode.untouched)">
            Kod polecający jest nieprawidłowy
          </mat-error>
        </mat-form-field>

        <mat-error class="error-message" *ngFor="let error of errors">
          {{ errorMessages[error] }}
        </mat-error>


      </mat-card-content>
      <mat-card-actions fxLayout="column" class="flex" style="align-self: center;">
        <ng-content select="[buttons]"></ng-content>
      </mat-card-actions>
      <mat-card-footer>
        <div class="lock" fxLayout="column" fxLayoutAlign="center center">
          <img src="/assets/images/icons/lock.svg"  alt="Bezpieczne logowanie" />
        </div>
      </mat-card-footer>
    </form>
  </mat-card>
</app-container>
